import { z } from "zod";
import { OutputContentId } from "../../idTypeBrands.js";

import { zDateTimeString } from "../../dateTypes.js";

/**
 * An output content as it appears inside another event's payload, before it has
 * been associated with an output.
 */
export const zUnattachedOutputContent = z.object({
  id: OutputContentId,
  createdDate: zDateTimeString,
  mimeType: z.string(),
});
